import ApiClientMobile from 'services/api/ApiClientMobile';

import {
    ICompleteWorkout,
    IPersonalPlanResponse,
    IStatisticPersonalPlanResponse,
    IWorkoutQueryParams,
    IWorkoutResponse,
} from './types';

class PersonalPlanApi {
    getCurrentPersonalPlan = async <Response = IPersonalPlanResponse>(): Promise<Partial<Response> | unknown> =>
        await ApiClientMobile.get<Response>('v2/plan');

    generatePersonalPlan = async <Data = object>(payload: Data): Promise<Partial<Response> | unknown> => {
        return await ApiClientMobile.post<Data>('v2/plan', payload);
    };

    getStatisticPersonalPlan = async <Data = number, Response = IStatisticPersonalPlanResponse>(
        id: Data
    ): Promise<Partial<Response> | unknown> => await ApiClientMobile.get<Response>(`user/plan/${id}/statistics`);

    getWorkout = async ({
        workout_id,
        workout_type,
        day_number,
    }: IWorkoutQueryParams): Promise<Partial<IWorkoutResponse> | unknown> =>
        await ApiClientMobile.get<IWorkoutQueryParams>(
            `v2/plan/workout?workout_id=${workout_id}&workout_type=${workout_type}&day_number=${day_number}`
        );

    completeWorkout = async <Data extends ICompleteWorkout>(payload: Data): Promise<Partial<Response> | unknown> => {
        return await ApiClientMobile.post<Data>('v2/plan/workout/complete', payload);
    };

    joinBranchContent = async <Data = { branch: string }>(payload: Data): Promise<Partial<Response> | unknown> =>
        await ApiClientMobile.post<Data>('join-branch-content', payload);
}

export default PersonalPlanApi;
